import { render, staticRenderFns } from "./FundamentalFormSummary.vue?vue&type=template&id=ffaaaa5e&scoped=true&"
import script from "./FundamentalFormSummary.vue?vue&type=script&lang=js&"
export * from "./FundamentalFormSummary.vue?vue&type=script&lang=js&"
import style0 from "./FundamentalFormSummary.vue?vue&type=style&index=0&id=ffaaaa5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaaaa5e",
  null
  
)

export default component.exports